import React, { Component } from 'react'
import './nocard.css' 
function Empty(){
            return (
            <div>
                <div className="noPost">
           No movie is released yet which includes these keywords
                </div>
            </div>
        )
    
}

export default Empty
